<template>
  <div class="scrm_wrap">
    <grid-component type="SCRM管理系统" />
  </div>
</template>

<script>
import GridComponent from '../../components/gridComponent.vue'
import { getDict } from '@/utils/dict'
export default {
  name: 'scrmIndex',
  components: {
    GridComponent
  },
  created() {
    const flag = this.$store.state.dictOptions
    if (flag && flag.crmCustType.length > 0) {} else {
      getDict()
    }
  }
}
</script>
<style lang="less">
.scrm_wrap {
  width: 100%;
  box-sizing: border-box;
  padding: 40px;
}
</style>
